import { render, staticRenderFns } from "./SPagination.vue?vue&type=template&id=6c30a792"
import script from "./SPagination.vue?vue&type=script&lang=js"
export * from "./SPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports